import React from "react";
import LinkButton from "../LinkButton";
import Logo from "./../../images/svg/logo_square.inline.svg";
import LetterLogo from "../../images/svg/letter_logo.svg";
import * as styles from "./style.module.css";
import { SimpleHeaderProps } from "../interface/interface";

const SimpleHeader: React.FC<SimpleHeaderProps> = ({trainer, thanks, form}) => (
  <header className={thanks ? styles.thanksheader : styles.header}>
    <nav className={thanks ? styles.thankswrapper : styles.wrapper}>
      <a
        className={thanks ? styles.thankslogowrap : styles.logowrap}
        href="/"
        aria-label="Main page"
        title="Main page"
      >
        <Logo width={40} height={40} />
      {trainer || form && <img src={LetterLogo} alt="gainful" className={styles.logo}  />}
      </a>
      {trainer && <LinkButton
        href="/quiz/"
        text="Take The Quiz"
        className={styles.simpleHeaderBtn}
      />}
      {form && <LinkButton
        href="/quiz/"
        text="log in"
        className={styles.simpleHeaderBtn}
      />}
    </nav>
  </header>
);

export default SimpleHeader;
